import React from 'react'
import './styles.css'
import {
  defineMessages,
  FormattedMessage
} from 'react-intl'
import Modal from 'components/Modal'
import Button from 'components/Button'

const messages = defineMessages({
  title: 'Warning',
  close: 'Close'
})

function BreakInWarningMessageModal(props) {
  const {
    show,
    closeModal,
    warningMessages,
    clearMessage
  } = props

  return (
    <Modal
      title={(<FormattedMessage {...messages.title} />)}
      show={show}
      footer={(
        <Button
          type='ok'
          onClick={() => {
            closeModal()
            clearMessage()
          }}
        >
          <FormattedMessage {...messages.close} />
        </Button>
      )}
    >
      <div data-testid='messageText' styleName='body'>
        {warningMessages && warningMessages[warningMessages.length - 1]}
      </div>
    </Modal>
  )
}

export default BreakInWarningMessageModal
